<template>
    <v-alert type="info" class="shape cutie my-1 text-left text-caption">
        {{ message }}
    </v-alert>
</template>

<script lang="ts">
import { Prop, Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'TableItemNotFoundAlert',
})
export default class TableItemNotFoundAlert extends Vue {
    @Prop({ default: '' }) message: string;
}
</script>
